import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/how-it-works', label: 'How It Works' },
  { to: '/packages', label: 'Packages' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Begin Your Story' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <nav data-testid="main-navbar" className="fixed top-0 left-0 right-0 z-50 bg-[#FCFBF9]/90 backdrop-blur-md border-b border-[#E7E5DF]">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 flex items-center justify-between h-16 sm:h-20">
        <Link to="/" className="font-['Cormorant_Garamond'] text-xl sm:text-2xl font-semibold text-[#1C1917] tracking-tight" data-testid="brand-logo">
          Heirloom Stories
        </Link>
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 ${
                location.pathname === link.to
                  ? 'text-[#1C1917]'
                  : 'text-[#78716C] hover:text-[#1C1917]'
              } ${link.to === '/contact' ? 'bg-[#1C1917] text-[#FCFBF9] hover:bg-[#322f2d] px-6 py-2.5' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </div>
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-[#1C1917]"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-[#FCFBF9] border-t border-[#E7E5DF] px-6 py-6 space-y-4 animate-fade-in">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setOpen(false)}
              className={`block text-base font-medium ${
                location.pathname === link.to ? 'text-[#1C1917]' : 'text-[#78716C]'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
